import React from 'react';
import { gettext } from '@eventbrite/i18n';
import PropTypes from 'prop-types';

import { StatusDotChunky } from '@eventbrite/eds-iconography';

export const SOLD_OUT_STATUS = 'soldOut';

export const UNAVAILABLE_STATUS = 'unavailable';

export const SALES_ENDED_STATUS = 'salesEnded';

export const SALES_NOT_STARTED_STATUS = 'salesNotStarted';

export const SALES_START_AFTER_STATUS = 'salesStartAfter';

export const SALES_START_SOON_STATUS = 'salesStartSoon';

export const ON_SALE_STATUS = 'onSale';

export const SALES_END_SOON_STATUS = 'salesEndSoon';

/* These constants should point to the relevant prop key to pull the
   time information from the passed-in props. */
const SALES_START_PROP_KEY = 'salesStart';
const SALES_END_PROP_KEY = 'salesEnd';
const SALES_ENDED_PROP_KEY = 'salesEnded';

const SOLD_OUT = {
    iconType: <StatusDotChunky />,
    iconColor: 'ui-red',
    displayStatus: gettext('Sold Out'),
};

const UNAVAILABLE = {
    iconType: <StatusDotChunky />,
    iconColor: 'ui-red',
    displayStatus: gettext('On Sale'),
    displayText: gettext('Unavailable'),
};

const SALES_ENDED = {
    iconType: <StatusDotChunky />,
    iconColor: 'grey-400',
    displayStatus: gettext('Ended'),
    datePropKey: SALES_ENDED_PROP_KEY,
};

const SALES_NOT_STARTED = {
    iconType: <StatusDotChunky />,
    iconColor: 'vibrant-yellow',
    displayStatus: gettext('Scheduled'),
    displayText: gettext('Starts on %(date)s'),
    datePropKey: SALES_START_PROP_KEY,
};

const SALES_START_AFTER = {
    iconType: <StatusDotChunky />,
    iconColor: 'vibrant-yellow',
    displayStatus: gettext('Scheduled'),
    displayText: gettext('Sales not started'),
};

const SALES_START_SOON = {
    iconType: <StatusDotChunky />,
    iconColor: 'vibrant-yellow',
    displayStatus: gettext('Scheduled'),
    displayText: gettext('Starts in %(date)s'),
    datePropKey: SALES_START_PROP_KEY,
};

const ON_SALE = {
    iconType: <StatusDotChunky />,
    iconColor: 'ui-green',
    displayStatus: gettext('On Sale'),
    displayText: gettext('Ends on %(date)s'),
    datePropKey: SALES_END_PROP_KEY,
};

const SALES_END_SOON = {
    iconType: <StatusDotChunky />,
    iconColor: 'ui-blue',
    displayStatus: gettext('On Sale'),
    displayText: gettext('Ends in %(date)s'),
    datePropKey: SALES_END_PROP_KEY,
};

export const STATUSES = [
    SOLD_OUT_STATUS,
    UNAVAILABLE_STATUS,
    SALES_ENDED_STATUS,
    SALES_NOT_STARTED_STATUS,
    SALES_START_AFTER_STATUS,
    SALES_START_SOON_STATUS,
    ON_SALE_STATUS,
    SALES_END_SOON_STATUS,
];

export const STATUSKEY_PROP_TYPE = PropTypes.oneOf(STATUSES);

export const TICKET_STATUS_MAP = {
    [SOLD_OUT_STATUS]: SOLD_OUT,
    [UNAVAILABLE_STATUS]: UNAVAILABLE,
    [SALES_ENDED_STATUS]: SALES_ENDED,
    [SALES_NOT_STARTED_STATUS]: SALES_NOT_STARTED,
    [SALES_START_AFTER_STATUS]: SALES_START_AFTER,
    [SALES_START_SOON_STATUS]: SALES_START_SOON,
    [ON_SALE_STATUS]: ON_SALE,
    [SALES_END_SOON_STATUS]: SALES_END_SOON,
};
